var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisibilityTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 244,
    height: 271.365,
    viewBox: "0 0 244 271.365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2523",
    "data-name": "Group 2523",
    transform: "translate(-1896 -2986)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 243.838,
    height: 271.365,
    transform: "translate(1896.162 2986)",
    fill: "#f8f8f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x2: 243.728,
    transform: "translate(1896.026 3026.81)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x2: 243.728,
    transform: "translate(1896.026 3046.01)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x2: 243.728,
    transform: "translate(1896.026 3065.209)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 243.728,
    transform: "translate(1896.026 3084.408)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x2: 243.728,
    transform: "translate(1896 3103.608)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x2: 243.728,
    transform: "translate(1896.026 3122.807)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    x2: 243.728,
    transform: "translate(1896.026 3142.007)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    x2: 243.728,
    transform: "translate(1896.026 3161.206)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    x2: 243.728,
    transform: "translate(1896.026 3180.406)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x2: 243.728,
    transform: "translate(1896.026 3199.605)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x2: 243.728,
    transform: "translate(1896.026 3218.804)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M0,0H243.728",
    transform: "translate(1896.026 3238.548)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    x2: 243.728,
    transform: "translate(1896.026 3007.611)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "Change",
    transform: "translate(2092 2999.491)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Change")), /*#__PURE__*/React.createElement("text", {
    id: "Keyword",
    transform: "translate(1909 2999.491)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Keyword")), /*#__PURE__*/React.createElement("text", {
    id: "Rank",
    transform: "translate(2036 2999.491)",
    fill: "#74ad85",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Rank")), /*#__PURE__*/React.createElement("text", {
    id: "_2_3_4_5_5_6_7_7_8_12_14_18_21",
    "data-name": "2 3 4 5 5 6 7 7 8 12 14 18 21",
    transform: "translate(2048 3020.551)",
    fill: "#74ad85",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 0
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 19.4
  }, "3"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 38.8
  }, "4"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 58.2
  }, "5"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 77.6
  }, "5"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 97
  }, "6"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 116.4
  }, "7"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 135.8
  }, "7"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 155.2
  }, "8"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 174.6
  }, "12"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 194
  }, "14"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 213.4
  }, "18"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 232.8
  }, "21")), /*#__PURE__*/React.createElement("text", {
    id: "_14_10_6_4_-_-2_2_3_-4_-_2_1_-",
    "data-name": "+14 +10 +6 +4 - -2 +2 +3 -4 - +2 +1 -",
    transform: "translate(2109 3020.551)",
    fill: "#74ad85",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.14,
    y: 0
  }, "+14"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.14,
    y: 19.4
  }, "+10"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.771,
    y: 38.8
  }, "+6"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.771,
    y: 58.2
  }, "+4"), /*#__PURE__*/React.createElement("tspan", {
    x: -1.655,
    y: 77.6
  }, "-"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#b94f4f"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.024,
    y: 97
  }, "-2")), /*#__PURE__*/React.createElement("tspan", {
    x: -6.771,
    y: 116.4
  }, "+2"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.771,
    y: 135.8
  }, "+3"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#b94f4f"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.024,
    y: 155.2
  }, "-4")), /*#__PURE__*/React.createElement("tspan", {
    x: -1.655,
    y: 174.6
  }, "-"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.771,
    y: 194
  }, "+2"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.771,
    y: 213.4
  }, "+1"), /*#__PURE__*/React.createElement("tspan", {
    x: -1.655,
    y: 232.8
  }, "-")), /*#__PURE__*/React.createElement("text", {
    id: "dentist_emergency_dentist_best_dentist_dentistry_dentists_dentist_close_to_me_best_dentist_near_me_dental_Cosmetic_dentist_DDS_dentist_nearby_family_dentist_family_dental_care",
    "data-name": "dentist emergency dentist best dentist dentistry dentists dentist close to me best dentist near me dental Cosmetic dentist DDS dentist nearby family dentist family dental care",
    transform: "translate(1910.104 3020.175)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "dentist"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19.4
  }, "emergency dentist"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 38.8
  }, "best dentist"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 58.2
  }, "dentistry"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 77.6
  }, "dentists"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 97
  }, "dentist close to me"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 116.4
  }, "best dentist near me"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 135.8
  }, "dental"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 155.2
  }, "Cosmetic dentist"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 174.6
  }, "DDS"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 194
  }, "dentist nearby"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 213.4
  }, "family dentist"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 232.8
  }, "family dental care")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityTable);
export default __webpack_public_path__ + "static/media/visibilityTable.c5b224c4.svg";
export { ForwardRef as ReactComponent };